import { gql } from '@apollo/client';

export const PATCH_OBJECTIVE_CRITERION_MUTATION = gql`
    mutation patchObjectiveCriterion($input: PatchObjectiveCriterionInput!) {
    Result:patchObjectiveCriterion(input:$input){
        id
        objectiveId
        criterionTypeId
        targetCount
        weight
        isEnabled
        targetValue
        locales {
                code,
                name,
                description
            }
    }
    }
`;